import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Output,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { TRANSLOCO_SCOPE, TranslocoService } from '@jsverse/transloco';
import {
  QaiButtonComponent,
  QaiDialogComponent,
  QaiFloatingSelectComponent,
  QaiFloatingSelectOption,
  QaiLabelComponent,
} from '@qai/ui';
import { GenderService } from 'src/app/services/general/gender.service';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { CallStoreService } from '../library/call-store/call-store.service';
@Component({
  selector: 'app-gender-selection-modal',
  templateUrl: './gender-selection-modal.component.html',
  styleUrls: ['./gender-selection-modal.component.scss'],
  standalone: true,
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'call',
    },
  ],
  imports: [
    CommonModule,
    QaiFloatingSelectComponent,
    QaiLabelComponent,
    QaiButtonComponent,
    QaiDialogComponent,
  ],
})
export class GenderSelectionModalComponent implements AfterViewInit {
  @ViewChild(QaiDialogComponent) dialogRef!: QaiDialogComponent;
  @Output() readonly valueChange = new EventEmitter<string>();
  @Output() readonly genderSaved = new EventEmitter<void>();

  heading: string = '';
  description: string = '';
  placeholder = '';
  dropdownLabel = '';
  buttonText = '';
  selectedValue?: string;
  genderOptions: QaiFloatingSelectOption[] = [];
  message: { [key: string]: string } = {};

  private isRequestInProgress = false;

  constructor(
    private genderService: GenderService,
    private translocoService: TranslocoService,
    private logger: LoggerService,
    private callStore: CallStoreService
  ) {}

  ngOnInit() {
    this.selectedValue = 'male';
    this.initializeTranslations();
  }

  private initializeTranslations() {
    this.heading = this.translocoService.translate('TELL_YOUR_GENDER_HEADING', {}, 'call');
    this.description = this.translocoService.translate('BY_KNOWING_YOUR_GENDER_DESCRIPTION', {}, 'call');
    this.placeholder = this.translocoService.translate('SELECT_OPTION', {}, 'call');
    this.dropdownLabel = this.translocoService.translate('GENDER_SELECTION', {}, 'call');
    this.buttonText = this.translocoService.translate('CONFIRM', {}, 'call');

    this.genderOptions = [
      { value: 'male', label: this.translocoService.translate('MALE', {}, 'call') },
      { value: 'female', label: this.translocoService.translate('FEMALE', {}, 'call') },
      { value: 'nonbinary', label: this.translocoService.translate('NON_BINARY', {}, 'call') },
      { value: 'preferNot', label: this.translocoService.translate('PREFER_NOT_TO_ANSWER', {}, 'call') },
    ];

    this.message = {
      nonbinary: this.translocoService.translate('NON_BINARY_MESSAGE', {}, 'call'),
      preferNot: this.translocoService.translate('PREFER_NOT_TO_ANSWER_MESSAGE', {}, 'call'),
    };
  }

  ngAfterViewInit() {
    this.logger.log('[CALL] gender selection modal - display');
    this.dialogRef?.showModal();
  }

  onValueChange(val: string) {
    this.logger.log('[CALL] gender selection modal - selection', {
      gender: val
    });
    this.selectedValue = val;
    this.valueChange.emit(val);
  }

  onConfirm() {
    if (this.isRequestInProgress) {
      return;
    }
    this.handleConfirmClick();
  }

  private handleConfirmClick() {
    if (this.selectedValue) {
      this.saveGender(this.selectedValue);
    }
  }

  private saveGender(selectedGender: string) {
    if (this.isRequestInProgress) {
      return;
    }
    this.isRequestInProgress = true;

    const userUuid = localStorage.getItem('user_uuid');
    if (!userUuid) {
      console.error('User UUID not found in localStorage.');
      return;
    }
    console.log('selectedGender: ', selectedGender);

    // Map nonbinary/preferNot to 'male'
    let genderToSave = selectedGender;
    if (selectedGender === 'nonbinary' || selectedGender === 'preferNot') {
      genderToSave = 'male';
    }

    this.genderService.saveUserGender(userUuid, genderToSave).subscribe(() => {
      console.log('genderToSave: ', genderToSave);
      localStorage.setItem('user_gender', genderToSave.toLocaleLowerCase());
      this.genderSaved.emit();
      this.isRequestInProgress = false;
    });
  }
}
